class SpoOrderQuote {
	constructor() {
		this.supplier = null
		this.dispatch_location = null
		this.order_items = []
		this.supplier_invoices = null

		this.supplier_po_amount = 0
		this.supplier_po_date = null
		this.supplier_po_document = null
		this.supplier_po_number = null
		this.supplier_po_status = 'ACTIVE'
		this.payment_terms_list = null
		this.billing_address = null
		this.payment_terms_list = []
		this.minimum_order_quantity = null
		this.quote_type = 'FOR'
		this.message = null
		this.terms_and_conditions = ''
		this.original_supplier_po_number = null
	}
}

export default SpoOrderQuote